import { ArrowDropDown, ArrowDropUp } from '@lichtblick/icons';
import { Colors } from '@lichtblick/theme';
import { TableSorterColumns, ListSortDirection } from '@lichtblick/types';

import { Container } from './TableSorter.styles';

type TableSorterTypes = {
  filteredHeaders?: TableSorterColumns;
  headerId: string;
  onCustomSort: (property: string, direction?: ListSortDirection) => void;
};

export const TableSorter = ({ filteredHeaders, headerId, onCustomSort }: TableSorterTypes) => {
  const onSort = () => {
    if (!filteredHeaders?.[headerId]) {
      return onCustomSort(headerId, ListSortDirection.Ascending);
    }

    if (filteredHeaders[headerId] === ListSortDirection.Ascending) {
      return onCustomSort(headerId, ListSortDirection.Descending);
    }

    if (filteredHeaders[headerId] === ListSortDirection.Descending) {
      return onCustomSort(headerId, undefined);
    }
  };

  return (
    <Container onClick={onSort}>
      {filteredHeaders?.[headerId] ? (
        <>
          {filteredHeaders[headerId] === ListSortDirection.Ascending ? (
            <ArrowDropUp style={{ color: Colors.blue[100] }} viewBox="6 6 12 12" />
          ) : (
            <ArrowDropDown height={12} style={{ color: Colors.blue[100] }} viewBox="6 6 12 12" />
          )}
        </>
      ) : (
        <>
          <ArrowDropUp height={12} style={{ color: Colors.gray[50] }} viewBox="6 6 12 12" />
          <ArrowDropDown height={12} style={{ color: Colors.gray[50] }} viewBox="6 6 12 12" />
        </>
      )}
    </Container>
  );
};
